export enum GraphicTypes {
    LINE = "line",
    RECTANGLE = "rectangle",
    IMAGE = "image",
    TEXT = "text",
    OVAL = "oval",
    POLYGON = "polygon"
}